module.exports = __webpack_public_path__ + "static/img/nh-university-hr-system.93a87f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/nh-university-hr-system.jpg
// module id = 0Gby
// module chunks = 0